import rem from 'polished/lib/helpers/rem'
import * as React from 'react'
import styled from 'styled-components'

// Display flex just as a fallback
const Root = styled.div<{ $itemCount: number }>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  display: grid;
  margin: 0;
  gap: ${rem(20)};

  @media (min-width: 576px) {
    grid-template-columns: ${({ $itemCount }) => $itemCount <= 2
    ? `repeat(${$itemCount}, minmax(min(100%, ${rem(280)}), ${rem(348)}))`
    : `repeat(auto-fit, minmax(min(100%, ${rem(280)}), 1fr))`};
  }
`

const Wrapper = styled.div`
  display: flex;
  justify-content: start;

  & > * {
    width: 100%;
  }

  @media (min-width: 576px) {
    justify-content: stretch;

    & > * {
      width: 100%;
      min-height: ${rem(416)};
    }
  }
`

interface Props {
  children: React.ReactNode
}

function CalendarPickerGridLayout(props: Props) {
  const itemCount = React.Children.count(props.children)

  return (
    <Root $itemCount={itemCount} data-testid="flexwrap-recommendations">
      {React.Children.map(props.children, (child) => (
        <Wrapper>
          {child}
        </Wrapper>
      ))}
    </Root>
  )
}

export default CalendarPickerGridLayout
